import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import {useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Iconbtn from '../../../common/Iconbtn'
import { changePassword } from '../../../../services/operations/SettingsAPI'
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai"

const ChangePassword = () => {
    const {token} = useSelector((state) => state.auth)
    const navigate = useNavigate()
    const [showOldPassword, setShowOldPassword] = useState(false)
    const [showNewPassword, setShowNewPassword] = useState(false)

    const {
        register,
        handleSubmit,
        formState: {errors},
     } = useForm()

     const submitHandler = async(data) => {
        //console.log("form data", data)
        try {
          await changePassword(token, data) 
        } catch (error) {
            console.log("ERROR WHILE UPDATING PASSWORD", error.message)
        }
     }
  
     return (
    <>
        <form onSubmit={handleSubmit(submitHandler)}>
        <div className='my-10 flex flex-col  gap-y-6 rounded-md border-[1px] border-richblack-700 bg-richblack-800 p-3 py-5 lg:p-8 lg:px-12'>
        <h2 className="text-lg font-semibold text-richblack-5">Password</h2>
            <div className='flex flex-col w-full gap-5 lg:flex-row'>
            <div className='relative flex flex-col gap-2  lg:w-[48%]'>
                <label htmlFor='oldPassword' className='lable-style'>
                    Current Password
                </label>
                <input
                    type={showOldPassword ? "text" : "password"}
                    name='oldPassword'
                    id='oldPassword'
                    placeholder='Enter your old password'
                    className='form-style'
                    {...register("oldPassword", {required: true})}
                />
                <span
                    onClick={() => setShowOldPassword((prev) => !prev)}
                    className='absolute right-3 top-[40px] z-[10] cursor-pointer'
                >
                    {
                        showOldPassword ? <AiOutlineEyeInvisible size={24} fill='#AFB2BF' /> : <AiOutlineEye size={24} fill='#AFB2BF'/>
                    }
                </span>
                {
                    errors.oldPassword && (
                        <span className='mt-1 text-[12px] text-yellow-100'>
                            Please your old password
                        </span>
                    )
                }
            </div>
            <div className='relative flex flex-col gap-2 lg:w-[48%]'>
                <label htmlFor='newPassword' className='lable-style'>
                    New Password
                </label>
                <input
                    type={showNewPassword ? "text" : "password"}
                    name='newPassword'
                    id='newPassword'
                    placeholder='Enter your old password'
                    className='form-style'
                    {...register("newPassword", {required: true})}
                />
                <span 
                    className='absolute right-3 top-[40px] z-[10] cursor-pointer'
                    onClick={() => setShowNewPassword((prev) => !prev)}
                >
                    {
                        showNewPassword ? <AiOutlineEyeInvisible size={24} fill='#AFB2BF' /> : <AiOutlineEye size={24} fill='#AFB2BF'/>
                    }
                </span>
                {
                    errors.oldPassword && (
                        <span className='mt-1 text-[12px] text-yellow-100'>
                            Please your new password
                        </span>
                    )
                }
            </div>
            </div>
            
            
        </div>
        <div className='flex justify-end gap-5'>
            <button
            onClick={() => {
                navigate("/dashboard/my-profile")
            }}
            className='cursor-pointer rounded-md bg-richblack-700 py-2 px-5 font-semibold text-richblack-50'
            >
                Cancel
            </button>     
            <Iconbtn
                text="Update"
                type="submit"
            />   
        </div>
        </form>
    </>
  )
}

export default ChangePassword